export default __webpack_public_path__ + "f315cc580b4c9788be7c7fe6b804c8b5.woff";